function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/FIGURES/ico-30-ascenseur");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/FIGURES/ico-30-ascenseur",
  stroke: "#D93252"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.5,3.57692308 L26.5,3.57692308 M26.5,26.5 L26.5,3.65384615 M3.5,26.5769231 L26.5,26.5769231 M3.5,26.5 L3.5,3.65384615 M15.5,18.5769231 L18.4808917,21.5769231 M21.5,18.5769231 L18.4808917,21.5769231 M8.5,11.5769231 L11.4808917,8.57692308 M14.5,11.5769231 L11.4808917,8.57692308 M18.5,8.57692308 L18.5,20.5769231 M11.5,8.57692308 L11.5,21.5769231",
  id: "steps"
})));

const SvgIco30Ascenseur = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30Ascenseur, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-ascenseur.0078c70c.svg";
export { ForwardRef as ReactComponent };